import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from '../../../../store';
import { GET_USER_DATA_URL, RESIGN_FROM_NEWSLETTER } from '../../../../api/apiRoutes';
import { post } from '../../../../api';
import { useTranslation } from 'react-i18next';
import useFacility from '../../../../../utils/hooks/useFacility';
import EAButton from '../../../shared/Buttons/EAButton';
import EAModal from '../../../shared/Modal/EAModal';
import EAAlert from '../../../shared/EAAlert';
import { MdCheckCircle } from 'react-icons/md';
import './SettingsTab.scss';
import EADivider from '../../../shared/EADivider';
import { getUserDataByToken } from '../../../../store/auth/authActions';

const NewsletterSection: React.FC = () => {
  const { t } = useTranslation();
  const facilityIds = useFacility();
  const dispatch = useDispatch();

  const userData = useSelector((state: State) => state.auth.userData);
  const allowMailing = userData.allowMailing;

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isResigning, setIsResigning] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  if (!allowMailing) {
    return null;
  }

  const handleOpenConfirmation = () => {
    setOpenConfirmation(true);
  };

  const handleCloseConfirmation = () => {
    setOpenConfirmation(false);
  };

  const handleResignFromNewsletter = async () => {
    setIsResigning(true);
    const { isError } = await post(RESIGN_FROM_NEWSLETTER(facilityIds, userData.email));

    if (!isError) {
      setSuccessMessage(t('wypisales_sie_z_newslettera'));
      setOpenConfirmation(false);
      dispatch(getUserDataByToken(GET_USER_DATA_URL(facilityIds)));
    }

    setIsResigning(false);
  };

  return (
    <>
      <div className="settings-section">
        <div className="settings-section__header">
          <h5>{t('newsletter')}</h5>
        </div>

        <div className="settings-section__content">
          {successMessage ? (
            <EAAlert
              message={successMessage}
              type="success"
              showOnlyIcon={false}
              compact={false}
            />
          ) : (
            <>
              <div className="newsletter-subscription">
                <div className="newsletter-subscription__status">
                  <MdCheckCircle className="newsletter-subscription__icon" />
                  <span>{t('jestes_zapisany_do_newslettera')}</span>
                </div>
              </div>

              <div className="settings-section__actions">
                <EAButton
                  title={t('wypisz_sie_z_newslettera')}
                  onClick={handleOpenConfirmation}
                  variant="outlined"
                  color="secondary"
                />
              </div>
            </>
          )}
        </div>
      </div>

      {openConfirmation && (
        <EAModal
          isOpen={openConfirmation}
          onClose={handleCloseConfirmation}
          title={t('potwierdzenie_rezygnacji_z_newslettera')}
          acceptButtonLabel={t('wypisz_sie')}
          cancelButtonLabel={t('anuluj')}
          onAccept={handleResignFromNewsletter}
          loading={isResigning}
        >
            <p>{t('czy_na_pewno_chcesz_wypisac_sie_z_newslettera')}</p>
        </EAModal>
      )}

        <EADivider />
    </>
  );
};

export default NewsletterSection;
